export const handleTrackingIdInSessionStorage = errorMessageData => {
  const trackingId = JSON.parse(sessionStorage.getItem('trackingId'));
  if (!trackingId) {
    sessionStorage.setItem('trackingId', JSON.stringify(errorMessageData.tracking));
  }

  return trackingId;
};
